import { Box } from "@mui/material";
import React from "react";

import { IProfileGroupedAssetClasses } from "store/types/user/social";
import { AssetTable } from "./TableAsset";

interface ITableAssetClassesProps {
  data: IProfileGroupedAssetClasses;
}

export const AssetClasses: React.FC<ITableAssetClassesProps> = ({ data }) => {
  if (!Object.values(data).length) return null;

  return (
    <div style={{ width: "100%", borderRadius: "8px", backgroundColor: "#fff" }}>
      <Box sx={{ padding: "22px" }}>
        {Object.entries(data).map(([title, data], index: number) => {
          return <AssetTable key={index} groupTitle={title} data={data} index={index} />;
        })}
      </Box>
    </div>
  );
};
